var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-controls" }, [
    _c("div", { staticClass: "left" }, [
      _c(
        "button",
        { attrs: { type: "button" }, on: { click: _vm.showEvents } },
        [_vm._v("Events")]
      ),
      _vm._v(" "),
      _c("strong", [_vm._v("&")]),
      _c("br"),
      _vm._v(" "),
      _c(
        "button",
        { attrs: { type: "button" }, on: { click: _vm.showContact } },
        [_vm._v("Contact")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right" }, [
      _c(
        "button",
        { attrs: { type: "button" }, on: { click: _vm.showArchive } },
        [_vm._v("Archive")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }